export default "/images/vendor/flag-icon-css/flags/1x1/as.svg?b326528d8d1f9c76ae82095561c3e29d";